<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            label="Save"
                            @click="updateSlaInfo"
                            :disabled="!$checkRole($accessModule.sla, 'create')"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card classContent="mt-4 mb-0">
                                <b-row class="mt-10">
                                <b-col md="4">
                                    <gofix-form-tree
                                        label="Service Category"
                                        :multiple="false"
                                        :options="serviceCategories"
                                        :load-options="loadOptionServices"
                                        :auto-load-root-options="false"
                                        valueFormat="object"
                                        v-model="slaInfo.service_category"
                                        :normalizer="normalizer"
                                        placeholder=""
                                        required
                                        @change="selectedServiceCategory">
                                    </gofix-form-tree>
                                </b-col>
                            </b-row>
                            </gofix-card>

                            <gofix-card classContent="mb-0" title="response time" v-if="slaInfo.response_time_data">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input label="Days" v-model="slaInfo.response_time_data.days"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Hours" v-model="slaInfo.response_time_data.hours"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Minutes" v-model="slaInfo.response_time_data.minutes"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>

                            <gofix-card classContent="mb-0" title="rectification time" v-if="slaInfo.rectification_time_data">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input label="Days" v-model="slaInfo.rectification_time_data.days"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Hours" v-model="slaInfo.rectification_time_data.hours"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Minutes" v-model="slaInfo.rectification_time_data.minutes"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>

                            <gofix-card classContent="mb-0" title="reaction time" v-if="slaInfo.reaction_time_data">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input label="Days" v-model="slaInfo.reaction_time_data.days"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Hours" v-model="slaInfo.reaction_time_data.hours"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Minutes" v-model="slaInfo.reaction_time_data.minutes"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mb-0" title="admin start time" v-if="slaInfo.admin_start_data">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input label="Days" v-model="slaInfo.admin_start_data.days"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Hours" v-model="slaInfo.admin_start_data.hours"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Minutes" v-model="slaInfo.admin_start_data.minutes"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mb-0" title="admin closure time" v-if="slaInfo.admin_closure_data">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input label="Days" v-model="slaInfo.admin_closure_data.days"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Hours" v-model="slaInfo.admin_closure_data.hours"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Minutes" v-model="slaInfo.admin_closure_data.minutes"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required, integer } from 'vuelidate/lib/validators'
    export default {
        name: 'basicInfo',
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                isServiceLoading: true,
                value: null,
                dataSla: {
                    id:this.$route.params.sla_id,
                    reaction_time: 0,
                    response_time: 0,
                    rectification_time: 0,
                    admin_start: 0,
                    admin_closure: 0,
                    service_category_id: null,
                    contract_id: this.$route.params.id,
                    priority: null
                },
                nodeServiceCategory: null,
            }
        },
        mixins: [validationMixin],
        validations: {
            dataSla: {
                service_category_id: {required},
                reaction_time: {integer},
            }
        },
        created() {
            this.$store.dispatch("v2SlaController/getServiceCategories", {
                contractId: this.$route.params.id,
                categoryId: 0
            }).then(response => {
                this.isServiceLoading = false;
            });
            this.$store.dispatch("v2SlaController/getSlaInfo", this.$route.params.sla_id)
            .then(response => {
                if (response) {
                    this.dataSla.service_category_id = response.service_category_id;
                    this.dataSla.reaction_time = response.reaction_time;
                    this.dataSla.response_time = response.response_time;
                    this.dataSla.rectification_time = response.rectification_time;
                    this.dataSla.admin_start = response.admin_start;
                    this.dataSla.admin_closure = response.admin_closure;
                    this.dataSla.priority = response.priority;
                }
            });             
        },
        filters: {
            formatDataToSeconds: function(value) {
                let seconds = 0;
                if(value.days){
                    seconds += parseInt(value.days) * 24 * 60 * 60;
                }
                if(value.hours){
                    seconds += parseInt(value.hours) * 60 * 60;
                }
                if(value.minutes){
                    seconds += parseInt(value.minutes) * 60;
                }
                if(value.seconds){
                    seconds += parseInt(value.seconds);
                }
                return seconds;
            },
        },
        computed: {
            ...mapGetters({
                serviceCategories: 'v2SlaController/serviceCategories',
                slaInfo: 'v2SlaController/slaInfo',
            })
        },
        methods: {
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("v2SlaController/getServiceCategories", {
                        contractId: this.$route.params.id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                }else{
                    callback();
                }
            },
            updateSlaInfo() {
                this.$v.dataSla.$touch();
                if(!this.$v.dataSla.$error){
                    this.disabled = true;
                    let slaParams = Object.assign({}, this.dataSla);
                    slaParams.reaction_time = this.$options.filters.formatDataToSeconds(this.slaInfo.reaction_time_data);
                    slaParams.rectification_time = this.$options.filters.formatDataToSeconds(this.slaInfo.rectification_time_data);
                    slaParams.response_time = this.$options.filters.formatDataToSeconds(this.slaInfo.response_time_data);
                    slaParams.admin_closure = this.$options.filters.formatDataToSeconds(this.slaInfo.admin_closure_data);
                    slaParams.admin_start = this.$options.filters.formatDataToSeconds(this.slaInfo.admin_start_data);

                    this.$store.dispatch('v2SlaController/updateSlaInfo', slaParams)
                    .then(response => {
                        this.disabled = false;
                        if(response.status === 200) {
                            this.$nextTick(() => {
                                this.$v.dataSla.$reset()
                            });
                            this.$alertNotification(this.$notificationV2('editing', 'sla'));
                        }
                    })
                    .catch(error => {
                        this.disabled = false;
                        if(error.response) this.$alertNotification(error, "danger");
                    });
                }
            },
            normalizer(node) {
                if (node.isBatch)
                    return {
                        label: node.name,
                        children: node.children
                    };
                return {
                    label: node.name,
                    children: undefined
                }
            },
            selectedServiceCategory(value) {
                this.dataSla.service_category_id = value.id;
            }
        }
    }
</script>
